module.exports = __webpack_public_path__ + "static/img/ai_helper.dfe7903.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai_helper.png
// module id = GVPl
// module chunks = 34